var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 496,
    viewBox: "0 0 516 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 512,
    height: 492,
    rx: 12,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 511,
    height: 491,
    rx: 11.5,
    stroke: "#E1E5E9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.792 91.7905H54.1093V239.196H196.792V91.7905Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.777 91.7905H59.0936V239.196H201.777V91.7905Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.994 95.2843H62.6909V235.769H197.994V95.2843Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.613 95.2832H62.6887V235.766H194.613V95.2832Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.017 95.2843H127.338V235.769H130.017V95.2843Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.914 95.2832L74.312 235.766H70.7032L108.305 95.2832H111.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.164 93.1179H128.868V238.463H131.164V93.1179Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2665 95.2832L62.6887 228.231V155.155L78.7087 95.2832H98.2665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.614 108.031V121.516L164.03 235.766H160.421L194.614 108.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.614 135.261V208.337L187.276 235.766H167.718L194.614 135.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.134 284.729H187.617V283.766C187.617 281.874 185.497 280.369 182.975 280.471L177.302 280.701C174.965 280.795 173.134 282.243 173.134 283.995V284.729Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.814 285.223H220.98L224.028 258.47C223.98 257.47 223.155 256.683 222.153 256.683H209.312C208.31 256.683 207.485 257.47 207.437 258.47L201.814 285.223Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.563 217.335H177.348L182.725 267.864H177.941C177.149 267.864 176.437 267.222 176.353 266.429L171.281 218.77C171.197 217.978 171.771 217.335 172.563 217.335Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.964 267.865H251.669C252.462 267.865 253.037 267.223 252.952 266.43L247.88 218.771C247.795 217.979 247.084 217.337 246.292 217.337H174.586C173.794 217.337 173.218 217.979 173.303 218.771L178.374 266.43C178.46 267.223 179.171 267.865 179.964 267.865Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.304 263.197H248.923C249.615 263.197 250.115 262.637 250.042 261.945L245.617 220.365C245.544 219.673 244.923 219.113 244.231 219.113H176.612C175.92 219.113 175.42 219.673 175.493 220.365L179.918 261.945C179.991 262.637 180.612 263.197 181.304 263.197Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.096 283.145H224.668C225.242 283.145 225.707 283.61 225.707 284.184C225.707 284.758 225.242 285.223 224.668 285.223H201.096C200.522 285.223 200.057 284.758 200.057 284.184C200.057 283.61 200.522 283.145 201.096 283.145Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.04 293.427H201.416V284.621H143.04V293.427Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.705 382.961H307.162C307.343 382.961 307.492 382.813 307.497 382.631L309.801 293.427H303.066L305.369 382.631C305.375 382.813 305.524 382.961 305.705 382.961Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.662 382.961H361.028L351.526 293.427H344.791L357.662 382.961Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.761 382.961L153.668 293.427H146.933L137.43 382.961H140.761Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.766 293.427H355.42V284.621H184.766V293.427Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.089 382.961H193.958L193.961 382.957L195.393 293.427H188.659L190.089 382.961Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.606 283.04H246.395C246.583 283.04 246.735 282.887 246.735 282.698V280.807C246.735 280.618 246.582 280.465 246.395 280.465H245.111C244.956 280.465 244.82 280.569 244.781 280.719L244.277 282.61C244.219 282.827 244.382 283.04 244.606 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.135 283.04H243.924C244.112 283.04 244.266 282.887 244.266 282.698V280.807C244.266 280.618 244.112 280.465 243.924 280.465H242.64C242.485 280.465 242.349 280.569 242.31 280.719L241.806 282.61C241.748 282.827 241.91 283.04 242.135 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.663 283.04H241.451C241.64 283.04 241.793 282.887 241.793 282.698V280.807C241.793 280.618 241.64 280.465 241.451 280.465H240.167C240.013 280.465 239.877 280.569 239.838 280.719L239.334 282.61C239.275 282.827 239.439 283.04 239.663 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.192 283.04H238.98C239.169 283.04 239.322 282.887 239.322 282.698V280.807C239.322 280.618 239.169 280.465 238.98 280.465H237.696C237.542 280.465 237.406 280.569 237.367 280.719L236.863 282.61C236.804 282.827 236.968 283.04 237.192 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.721 283.04H236.509C236.698 283.04 236.851 282.887 236.851 282.698V280.807C236.851 280.618 236.698 280.465 236.509 280.465H235.225C235.071 280.465 234.935 280.569 234.896 280.719L234.392 282.61C234.333 282.827 234.497 283.04 234.721 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.25 283.04H234.038C234.227 283.04 234.38 282.887 234.38 282.698V280.807C234.38 280.618 234.227 280.465 234.038 280.465H232.754C232.6 280.465 232.464 280.569 232.425 280.719L231.921 282.61C231.862 282.827 232.026 283.04 232.25 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.779 283.04H231.567C231.756 283.04 231.909 282.887 231.909 282.698V280.807C231.909 280.618 231.756 280.465 231.567 280.465H230.283C230.129 280.465 229.993 280.569 229.954 280.719L229.45 282.61C229.391 282.827 229.555 283.04 229.779 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.308 283.04H229.096C229.285 283.04 229.437 282.887 229.437 282.698V280.807C229.437 280.618 229.284 280.465 229.096 280.465H227.812C227.658 280.465 227.522 280.569 227.483 280.719L226.979 282.61C226.92 282.827 227.083 283.04 227.308 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.836 283.04H226.624C226.813 283.04 226.966 282.887 226.966 282.698V280.807C226.966 280.618 226.813 280.465 226.624 280.465H225.34C225.186 280.465 225.05 280.569 225.011 280.719L224.507 282.61C224.448 282.827 224.612 283.04 224.836 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.365 283.04H224.153C224.342 283.04 224.495 282.887 224.495 282.698V280.807C224.495 280.618 224.342 280.465 224.153 280.465H222.869C222.715 280.465 222.579 280.569 222.54 280.719L222.035 282.61C221.977 282.827 222.141 283.04 222.365 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.894 283.04H221.682C221.871 283.04 222.024 282.887 222.024 282.698V280.807C222.024 280.618 221.872 280.465 221.682 280.465H220.398C220.244 280.465 220.108 280.569 220.069 280.719L219.564 282.61C219.506 282.827 219.67 283.04 219.894 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.423 283.04H219.211C219.4 283.04 219.553 282.887 219.553 282.698V280.807C219.553 280.618 219.4 280.465 219.211 280.465H217.927C217.773 280.465 217.637 280.569 217.598 280.719L217.093 282.61C217.035 282.827 217.199 283.04 217.423 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.952 283.04H216.74C216.929 283.04 217.082 282.887 217.082 282.698V280.807C217.082 280.618 216.929 280.465 216.74 280.465H215.456C215.302 280.465 215.165 280.569 215.127 280.719L214.622 282.61C214.564 282.827 214.726 283.04 214.952 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.481 283.04H214.269C214.458 283.04 214.611 282.887 214.611 282.698V280.807C214.611 280.618 214.458 280.465 214.269 280.465H212.985C212.831 280.465 212.694 280.569 212.656 280.719L212.151 282.61C212.092 282.827 212.255 283.04 212.481 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.008 283.04H211.797C211.986 283.04 212.139 282.887 212.139 282.698V280.807C212.139 280.618 211.986 280.465 211.797 280.465H210.513C210.358 280.465 210.222 280.569 210.183 280.719L209.679 282.61C209.621 282.827 209.784 283.04 210.008 283.04Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.211 284.73H248.193V281.753H208.211V284.73Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.459 211.218V67.674L282.702 67.674V211.218L467.459 211.218Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.263 208.657L464.898 208.657V70.2332L285.263 70.2332V208.657Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.066 95.2386V114.543",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.164 176.682V114.543H409.654V150.188",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.57 169.16V150.188H433.367V169.823",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.672 88.1459H351.461V102.33H392.672V88.1459Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.902 122.181H390.622V137.59H429.902V122.181Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.059 161.213H375.08V177.109H402.059V161.213Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.814 163.785H418.923V175.859H447.814V163.785Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.831 125.442H309.205V146.029H353.831V125.442Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.414 169.16H313.914V184.205H342.414V169.16Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.221 115.037L372.068 108.885L365.915 115.037L372.068 121.189L378.221 115.037Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.805 150.183L409.652 144.031L403.499 150.183L409.652 156.334L415.805 150.183Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07 357.811C158.995 356.259 157.69 353.921 155.882 353.894C156.675 351.666 155.893 348.973 154.031 347.514C153.796 347.33 153.527 347.157 153.227 347.157C152.907 347.156 152.623 347.352 152.364 347.538C150.66 348.761 148.956 349.986 147.253 351.209C146.863 351.489 146.459 351.785 146.238 352.212C145.194 354.235 148.96 356.828 147.412 358.498C146.967 358.977 146.251 359.077 145.696 359.423C144.48 360.184 144.333 361.853 143.766 363.171C143.199 364.488 141.223 365.511 140.466 364.292C141.024 363.028 139.335 361.94 137.962 361.78C136.608 361.622 135.157 361.544 134.398 360.257C132.45 361.958 128.092 357.211 128.191 355.296C126.59 355.418 125.5 356.917 125.149 358.415C124.786 359.97 125.011 361.591 124.986 363.186C124.937 366.285 123.936 369.32 123.991 372.42C124.033 374.832 124.965 377.51 127.174 378.48C128.238 378.947 129.439 378.948 130.599 378.94C138.982 378.886 147.364 378.832 155.746 378.779C156.35 378.775 156.98 378.765 157.514 378.485C158.648 377.893 158.889 376.403 158.994 375.127C159.444 369.665 159.894 364.203 160.344 358.741C159.586 358.43 158.828 358.12 158.07 357.811Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.537 331.235H156.712H148.938H146.104H138.339H135.506H127.74H124.907H120.516L120.837 335.177L121.066 337.991L121.662 345.314L122.001 349.521L122.451 355.122L122.643 357.524L122.707 358.239L122.937 361.061L123.249 364.929L123.442 367.331L123.643 369.77L123.873 372.592L124.047 374.728L124.239 377.13L124.321 378.175H129.456H133.792H140.053H144.389H150.651H154.987H160.13L160.213 377.13L160.405 374.737L160.578 372.583L160.808 369.761L161.01 367.331L161.202 364.929L161.514 361.052L161.743 358.239L161.797 357.524L161.99 355.122L162.448 349.521L162.788 345.323L163.374 337.991L163.603 335.177L163.924 331.235H159.537ZM161.884 333.82L161.132 333.069H161.948L161.884 333.82ZM161.691 336.213L161.618 337.166L158.125 340.659L154.118 336.653L157.703 333.069H158.547L161.691 336.213ZM160.684 348.697L158.126 351.255L154.119 347.249L158.126 343.252L160.894 346.02L160.684 348.697ZM123.553 346.021L126.321 343.253L130.328 347.25L126.321 351.256L123.773 348.698L123.553 346.021ZM156.832 341.951L152.826 345.957L148.819 341.951L152.826 337.945L156.832 341.951ZM150.534 333.069H155.118L152.827 335.36L150.534 333.069ZM151.525 347.249L147.527 351.255L143.52 347.249L147.527 343.252L151.525 347.249ZM138.223 352.546L142.229 348.55L146.227 352.546L142.229 356.552L138.223 352.546ZM140.927 357.846L136.92 361.851L132.924 357.855L136.93 353.849L140.927 357.846ZM147.527 353.849L151.525 357.855L147.527 361.851L143.52 357.846L147.527 353.849ZM142.228 345.957L138.221 341.951L142.228 337.945L146.226 341.951L142.228 345.957ZM140.927 347.249L136.93 351.255L132.924 347.249L136.93 343.252L140.927 347.249ZM131.621 345.957L127.624 341.951L131.621 337.945L135.628 341.951L131.621 345.957ZM131.621 348.551L135.628 352.548L131.621 356.554L127.624 352.548L131.621 348.551ZM135.627 363.153L131.62 367.149L127.623 363.153L131.62 359.147L135.627 363.153ZM136.92 364.444L140.927 368.45L136.93 372.456L132.924 368.45L136.92 364.444ZM138.223 363.153L142.229 359.147L146.227 363.153L142.229 367.149L138.223 363.153ZM147.527 364.444L151.525 368.45L147.527 372.456L143.52 368.45L147.527 364.444ZM152.826 369.742L156.832 373.748L154.238 376.342H151.414L148.819 373.748L152.826 369.742ZM148.82 363.153L152.827 359.147L156.834 363.153L152.827 367.149L148.82 363.153ZM148.82 352.546L152.827 348.55L156.834 352.546L152.827 356.552L148.82 352.546ZM151.525 336.653L147.527 340.659L143.52 336.653L147.105 333.069H147.949L151.525 336.653ZM142.228 335.36L139.937 333.069H144.512L142.228 335.36ZM140.927 336.653L136.93 340.659L132.924 336.653L136.509 333.069H137.352L140.927 336.653ZM133.913 333.069L131.621 335.36L129.339 333.069H133.913ZM126.743 333.069L130.328 336.653L126.321 340.659L122.837 337.166L122.764 336.213L125.899 333.069H126.743ZM123.315 333.069L122.572 333.811L122.508 333.069H123.315ZM123.067 339.989L125.029 341.951L123.361 343.619L123.067 339.989ZM124.158 353.418L124.002 351.52L125.029 352.546L124.158 353.418ZM124.351 355.829L126.323 353.849L130.329 357.855L126.323 361.851L124.709 360.238L124.351 355.829ZM124.947 363.235L124.938 363.061L125.029 363.153L124.947 363.235ZM125.643 371.768L125.139 365.627L126.321 364.444L130.328 368.45L126.321 372.447L125.643 371.768ZM126.01 376.342L125.937 375.425L126.323 375.04L127.625 376.341L126.01 376.342ZM127.624 373.748L131.621 369.742L135.628 373.748L133.034 376.342H130.21L127.624 373.748ZM135.628 376.342L136.93 375.041L138.232 376.342H135.628ZM140.816 376.342L138.221 373.748L142.228 369.742L146.226 373.748L143.64 376.342H140.816ZM146.226 376.342L147.527 375.041L148.829 376.342H146.226ZM158.437 376.342H156.823L158.125 375.041L158.51 375.427L158.437 376.342ZM158.813 371.768L158.126 372.446L154.119 368.449L158.126 364.443L159.308 365.625L158.813 371.768ZM159.518 363.051L159.5 363.234L159.418 363.151L159.518 363.051ZM159.748 360.237L158.126 361.85L154.119 357.853L158.126 353.848L160.106 355.828L159.748 360.237ZM160.298 353.427L159.418 352.546L160.454 351.52L160.298 353.427ZM161.389 339.98L161.095 343.628L159.418 341.951L161.389 339.98Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9 334.704H164.551C165.589 334.704 166.43 333.862 166.43 332.825V331.48C166.43 330.442 165.588 329.601 164.551 329.601H119.9C118.861 329.601 118.021 330.443 118.021 331.48V332.825C118.021 333.862 118.861 334.704 119.9 334.704Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06 380.535H123.391C122.352 380.535 121.512 379.693 121.512 378.656V377.311C121.512 376.273 122.354 375.432 123.391 375.432H161.06C162.098 375.432 162.939 376.274 162.939 377.311V378.656C162.939 379.693 162.097 380.535 161.06 380.535Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.178 340.58L455.333 305.55C455.333 305.55 438.473 318.047 438.586 304.192C438.698 290.336 446.267 301.096 448.895 295.978C451.522 290.86 441.415 290.914 444.961 283.153C448.508 275.391 458.588 287.317 460.368 280.441C462.149 273.566 464.987 270.068 472.328 270.686C472.328 270.686 476.294 279.732 471.432 286.267C466.569 292.802 483.46 287.567 481.744 294.142C480.028 300.717 474.388 306.455 471.905 301.825C469.42 297.194 466.268 306.066 470.514 308.35C474.76 310.635 464.964 320.535 462.814 315.346C460.664 310.157 457.295 305.536 457.295 305.536L446.092 343.014L443.178 340.58Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.649 340.89L416.945 318.489C416.945 318.489 430.5 324.589 428.328 315.019C426.157 305.449 422.546 314.037 419.955 310.893C417.362 307.748 424.365 306.259 420.738 301.424C417.111 296.59 411.939 306.363 409.668 301.875C407.397 297.386 404.904 295.395 399.919 296.931C399.919 296.931 398.541 303.79 402.893 307.577C407.245 311.365 394.767 310.294 396.948 314.583C399.129 318.873 403.898 321.992 404.918 318.413C405.937 314.835 409.459 320.496 406.866 322.719C404.274 324.94 412.548 330.311 413.252 326.396C413.955 322.48 415.588 318.773 415.588 318.773L429.003 343.014L430.649 340.89Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.879 341.105L433.604 305.019C433.604 305.019 448.053 319.886 450.149 306.359C452.245 292.832 443.153 302.118 441.406 296.71C439.659 291.301 449.504 292.963 447.282 284.832C445.059 276.7 433.334 286.723 432.693 279.737C432.051 272.749 429.841 268.89 422.586 268.323C422.586 268.323 417.278 276.512 420.979 283.657C424.681 290.802 409.046 283.011 409.673 289.693C410.299 296.376 414.884 302.868 418.043 298.75C421.201 294.631 422.862 303.783 418.359 305.334C413.857 306.886 421.832 318.097 424.754 313.38C427.675 308.662 431.697 304.693 431.697 304.693L436.654 343.015L439.879 341.105Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.654 381.678H426.11C424.604 381.678 423.358 380.506 423.265 379.003L420.981 341.852C420.881 340.213 422.183 338.827 423.826 338.827H449.937C451.581 338.827 452.883 340.212 452.782 341.852L450.499 379.003C450.406 380.506 449.16 381.678 447.654 381.678Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.513 343.014H420.986C419.538 343.014 418.321 341.929 418.155 340.491C417.959 338.799 419.282 337.314 420.986 337.314H452.513C454.216 337.314 455.539 338.799 455.344 340.491C455.178 341.929 453.96 343.014 452.513 343.014Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.587 314.929H312.787C315.944 314.929 318.504 317.488 318.504 320.645V322.809H257.869V320.645C257.869 317.488 260.429 314.929 263.587 314.929Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.529 367.676L297.1 365.767V338.467H289.4V365.759L269.893 367.676C267.957 367.867 266.481 369.495 266.481 371.44V374.357H292.498H293.925H319.942V371.44C319.941 369.494 318.465 367.866 316.529 367.676Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.57 377.975C273.57 380.755 271.316 383.009 268.536 383.009C265.756 383.009 263.501 380.755 263.501 377.975C263.501 375.195 265.755 372.941 268.536 372.941C271.316 372.941 273.57 375.195 273.57 377.975Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.852 377.975C312.852 380.755 315.105 383.009 317.886 383.009C320.667 383.009 322.921 380.755 322.921 377.975C322.921 375.195 320.667 372.941 317.886 372.941C315.105 372.941 312.852 375.195 312.852 377.975Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7 344.336H292.8C290.189 344.336 288.074 342.221 288.074 339.61V320.021H298.426V339.61C298.426 342.219 296.31 344.336 293.7 344.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.019 315.436C285.705 305.278 291.754 279.002 293.027 244.284C293.224 238.919 297.65 234.679 303.02 234.679H320.944C326.45 234.679 330.923 239.121 330.946 244.626C331.016 260.952 329.874 294.326 320.665 321.453L286.551 320.197C284.119 320.108 282.397 317.79 283.019 315.436Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.843 319.634C287.843 319.634 297.047 286.898 298.567 245.447C298.749 240.499 302.833 236.587 307.785 236.587H324.318C329.396 236.587 333.523 240.685 333.545 245.763C333.609 260.822 332.557 294.612 324.061 319.634H287.843Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.935 295.836C294.935 295.836 275.288 291.862 256.321 293.786C237.353 295.71 265.246 320.491 265.246 320.491H269.161C269.161 320.491 254.381 304.779 255.204 300.867C256.027 296.954 293.25 302.112 293.25 302.112L294.935 295.836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.059 319.636H291.887C291.887 319.636 301.091 286.897 302.615 245.448C302.797 240.5 306.877 236.589 311.833 236.589H324.314C329.398 236.589 333.518 240.688 333.545 245.765C333.607 260.819 332.555 294.61 324.059 319.636Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.678 318.87H322.742C323.83 318.87 324.712 319.752 324.712 320.839C324.712 321.928 323.83 322.809 322.742 322.809H257.678C256.59 322.809 255.708 321.927 255.708 320.839C255.708 319.751 256.59 318.87 257.678 318.87Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.424 434.021C387.869 434.021 487.13 428.225 487.13 421.076C487.13 413.926 387.869 408.131 265.424 408.131C142.979 408.131 43.7185 413.926 43.7185 421.076C43.7185 428.225 142.979 434.021 265.424 434.021Z",
    fill: "#0356B6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.936 52.9564V414.364C292.936 417.336 290.546 419.646 287.573 419.646H105.625C102.892 419.646 100.833 417.531 100.833 414.798V52.5219C100.833 50.1554 102.572 48.0861 104.939 48.0861H148.139C149.488 48.0861 150.712 48.9664 151.215 50.2354L153.193 55.1057C153.696 56.3633 154.919 57.2321 156.269 57.2321H237.604C238.953 57.2321 240.176 56.3976 240.679 55.14L242.658 50.2468C243.161 48.9778 244.384 48.0861 245.734 48.0861H288.248C290.855 48.0861 292.936 50.3497 292.936 52.9564Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M292.936 52.9564V414.364C292.936 417.336 290.546 419.646 287.573 419.646H105.625C102.892 419.646 100.833 417.531 100.833 414.798V52.5219C100.833 50.1554 102.572 48.0861 104.939 48.0861H148.139C149.488 48.0861 150.712 48.9664 151.215 50.2354L153.193 55.1057C153.696 56.3633 154.919 57.2321 156.269 57.2321H237.604C238.953 57.2321 240.176 56.3976 240.679 55.14L242.658 50.2468C243.161 48.9778 244.384 48.0861 245.734 48.0861H288.248C290.855 48.0861 292.936 50.3497 292.936 52.9564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.006 369.759H114.395C112.259 369.759 110.527 368.027 110.527 365.892V326.288C110.527 324.153 112.259 322.421 114.395 322.421H154.006C156.142 322.421 157.874 324.153 157.874 326.288V365.892C157.873 368.027 156.142 369.759 154.006 369.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.848 332.445H120.551V359.737H147.848V332.445Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.551 332.445V359.735H147.848V332.445H120.551ZM133.315 346.091L121.803 357.6V334.581L133.315 346.091ZM122.689 333.697H145.711L134.2 345.206L122.689 333.697ZM134.2 346.976L145.711 358.485H122.689L134.2 346.976ZM135.085 346.091L146.596 334.581V357.6L135.085 346.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M158.296 379.648H110.105V385.075H158.296V379.648Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.083 381.089H110.715V380.593H114.015V381.089H112.648V384.583H112.083V381.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.855 369.287H176.244C174.108 369.287 172.376 367.555 172.376 365.42V325.816C172.376 323.68 174.108 321.948 176.244 321.948H215.855C217.991 321.948 219.723 323.68 219.723 325.816V365.42C219.723 367.556 217.991 369.287 215.855 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M209.697 331.974H182.402V359.266H209.697V331.974Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.402 331.974V359.266H209.697V331.974H182.402ZM195.164 345.62L183.653 357.129V334.11L195.164 345.62ZM184.538 333.226H207.56L196.049 344.735L184.538 333.226ZM196.049 346.503L207.56 358.013H184.538L196.049 346.503ZM196.935 345.62L208.446 334.11V357.129L196.935 345.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M220.145 379.177H171.954V384.604H220.145V379.177Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.933 380.617H172.566V380.121H175.866V380.617H174.498V384.111H173.933V380.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.704 368.816H238.093C235.957 368.816 234.225 367.084 234.225 364.949V325.345C234.225 323.209 235.957 321.477 238.093 321.477H277.704C279.84 321.477 281.572 323.209 281.572 325.345V364.949C281.572 367.085 279.841 368.816 277.704 368.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.546 331.501H244.251V358.793H271.546V331.501Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M244.251 331.501V358.792H271.546V331.501H244.251ZM257.014 345.147L245.503 356.657V333.638L257.014 345.147ZM246.388 332.753H269.41L257.899 344.263L246.388 332.753ZM257.899 346.032L269.41 357.542H246.388L257.899 346.032ZM258.784 345.147L270.295 333.638V356.657L258.784 345.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M281.994 378.704H233.803V384.131H281.994V378.704Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.782 380.146H234.415V379.65H237.715V380.146H236.347V383.64H235.782V380.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.442 165.247H112.329C111.101 165.247 110.105 164.252 110.105 163.024V84.0302C110.105 82.8023 111.101 81.8065 112.329 81.8065H281.442C282.67 81.8065 283.666 82.8023 283.666 84.0302V163.024C283.665 164.252 282.67 165.247 281.442 165.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M118.557 125.213C120.681 125.213 122.403 123.491 122.403 121.368C122.403 119.244 120.681 117.523 118.557 117.523C116.433 117.523 114.712 119.244 114.712 121.368C114.712 123.491 116.433 125.213 118.557 125.213Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.664 121.368L119.634 123.382V119.353L116.664 121.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M275.212 125.213C277.336 125.213 279.058 123.491 279.058 121.368C279.058 119.244 277.336 117.523 275.212 117.523C273.088 117.523 271.367 119.244 271.367 121.368C271.367 123.491 273.088 125.213 275.212 125.213Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.106 121.368L274.135 119.353V123.382L277.106 121.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M235.758 101.996H138.914V111.648H235.758V101.996Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M235.758 114.528H138.914V124.179H235.758V114.528Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M218.229 128.016H138.914V137.667H218.229V128.016Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.433 104.56H140V103.678H145.869V104.56H143.437V110.773H142.433V104.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M181.09 160.598C181.09 161.556 180.314 162.332 179.357 162.332C178.398 162.332 177.623 161.556 177.623 160.598C177.623 159.641 178.399 158.865 179.357 158.865C180.314 158.863 181.09 159.64 181.09 160.598Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M189.855 160.598C189.855 161.556 189.078 162.332 188.12 162.332C187.163 162.332 186.387 161.556 186.387 160.598C186.387 159.641 187.163 158.865 188.12 158.865C189.078 158.863 189.855 159.64 189.855 160.598Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M198.619 160.598C198.619 161.556 197.843 162.332 196.886 162.332C195.928 162.332 195.151 161.556 195.151 160.598C195.151 159.641 195.928 158.865 196.886 158.865C197.843 158.863 198.619 159.64 198.619 160.598Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M207.384 160.598C207.384 161.556 206.608 162.332 205.651 162.332C204.692 162.332 203.917 161.556 203.917 160.598C203.917 159.641 204.694 158.865 205.651 158.865C206.608 158.863 207.384 159.64 207.384 160.598Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M216.148 160.598C216.148 161.556 215.371 162.332 214.414 162.332C213.457 162.332 212.681 161.556 212.681 160.598C212.681 159.641 213.457 158.865 214.414 158.865C215.372 158.863 216.148 159.64 216.148 160.598Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.666 177.031H110.105V190.587H283.666V177.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M283.665 176.873H269.792V190.743H283.665V176.873Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.971 253.733H113.077C111.435 253.733 110.104 252.403 110.104 250.761V204.042C110.104 202.4 111.435 201.069 113.077 201.069H266.971C268.613 201.069 269.943 202.4 269.943 204.042V250.761C269.943 252.403 268.613 253.733 266.971 253.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.228 208.372H117.235V246.432H167.228V208.372Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.235 208.372V246.432H167.228V208.372H117.235ZM164.951 209.515L142.232 226.685L119.512 209.515H164.951ZM118.379 210.093L141.284 227.403L118.379 244.713V210.093ZM119.512 245.289L142.232 228.119L164.951 245.289H119.512ZM143.18 227.402L166.084 210.092V244.711L143.18 227.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M263.607 208.94H174.991V213.898H263.607V208.94Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M263.607 217.662H174.991V222.62H263.607V217.662Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M215.726 226.877H174.991V231.834H215.726V226.877Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.799 210.256H175.549V209.804H178.563V210.256H177.313V213.447H176.797V210.256H176.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.971 310.896H113.077C111.435 310.896 110.104 309.566 110.104 307.924V261.205C110.104 259.563 111.435 258.233 113.077 258.233H266.971C268.613 258.233 269.943 259.564 269.943 261.205V307.924C269.943 309.566 268.613 310.896 266.971 310.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.228 265.535H117.235V303.596H167.228V265.535Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.235 265.535V303.596H167.228V265.535H117.235ZM164.951 266.679L142.232 283.848L119.512 266.679H164.951ZM118.379 267.256L141.284 284.566L118.379 301.876V267.256ZM119.512 302.452L142.232 285.282L164.951 302.452H119.512ZM143.18 284.565L166.084 267.255V301.874L143.18 284.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M263.607 266.104H174.991V271.061H263.607V266.104Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M263.607 274.825H174.991V279.783H263.607V274.825Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M215.726 284.04H174.991V288.997H215.726V284.04Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.799 267.419H175.549V266.967H178.563V267.419H177.313V270.61H176.797V267.419H176.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.994 201.125H275.816V310.896H281.994V201.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M281.994 207.091H275.816V224.286H281.994V207.091Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.936 52.9585V70.6676H100.833V52.5241C100.833 50.1576 102.572 48.0883 104.939 48.0883H148.139C149.488 48.0883 150.712 48.9686 151.215 50.2376L153.193 55.1079C153.696 56.3655 154.919 57.2343 156.269 57.2343H237.604C238.953 57.2343 240.176 56.3998 240.679 55.1422L242.658 50.249C243.161 48.98 244.384 48.0883 245.734 48.0883H288.248C290.855 48.0883 292.936 50.3519 292.936 52.9585Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.833 395.639H292.936V414.366C292.936 417.338 290.546 419.648 287.573 419.648H105.625C102.892 419.648 100.833 417.533 100.833 414.8V395.639Z",
    fill: "#A3CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.121 49.9622H56.2887V66.9156H91.121V49.9622Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0564 54.5867H85.3534",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0564 58.4384H85.3534",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0564 62.2911H73.7049",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6605 66.2194L115.039 96.0299",
    stroke: "#407BFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.039 98.1071C116.186 98.1071 117.117 97.1771 117.117 96.0298C117.117 94.8826 116.186 93.9525 115.039 93.9525C113.891 93.9525 112.961 94.8826 112.961 96.0298C112.961 97.1771 113.891 98.1071 115.039 98.1071Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6903 260.677H52.858V277.631H87.6903V260.677Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6257 265.302H81.9227",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6257 269.155H81.9227",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6257 273.006H70.2742",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.608 271.232C112.756 271.232 113.686 270.302 113.686 269.155C113.686 268.008 112.756 267.078 111.608 267.078C110.461 267.078 109.531 268.008 109.531 269.155C109.531 270.302 110.461 271.232 111.608 271.232Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.608 269.155H85.5978",
    stroke: "#407BFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.628 180.858L309.86 143.268",
    stroke: "#407BFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.726 130.218H298.893V147.171H333.726V130.218Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.661 134.842H327.957",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.661 138.695H327.957",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.661 142.547H316.308",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.628 182.936C260.775 182.936 261.706 182.006 261.706 180.858C261.706 179.711 260.775 178.781 259.628 178.781C258.48 178.781 257.55 179.711 257.55 180.858C257.55 182.006 258.48 182.936 259.628 182.936Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.138 355.355H302.305V372.309H337.138V355.355Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.073 359.98H331.37",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.073 363.832H331.37",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.073 367.684H319.722",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.119 363.832C265.119 364.979 264.188 365.909 263.041 365.909C261.893 365.909 260.963 364.978 260.963 363.832C260.963 362.684 261.894 361.754 263.041 361.754C264.188 361.754 265.119 362.685 265.119 363.832Z",
    fill: "#C65247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.04 363.832H304.874",
    stroke: "#407BFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.209 176.755C368.359 176.93 352.221 198.597 352.221 198.597L346.228 190.808C346.228 190.808 336.989 208.756 341.558 217.299C346.128 225.841 370.215 202.489 370.215 202.489L372.209 176.755Z",
    fill: "#EEB447"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M370.622 194.038L370.216 202.486C370.216 202.486 366.256 206.324 361.249 210.314C360.771 200.171 370.216 185.398 370.216 185.398L370.622 194.038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M352.221 198.597L353.083 200.247L350.571 210.02C350.571 210.02 357.499 203.716 353.083 197.54L352.221 198.597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.515 230.93L404.011 233.439C404.011 233.439 404.454 214.029 407.042 203.927C407.885 200.657 408.942 196.983 410.282 192.719C410.85 190.911 411.47 189.003 412.15 186.962C412.769 185.063 413.45 183.043 414.191 180.921C409.743 179.5 405.214 178.414 400.603 177.643C395.749 176.779 390.835 176.261 385.9 176.089C379.533 176.039 372.211 176.759 372.211 176.759C372.211 176.759 371.175 177.013 370.515 183.754C369.916 190.098 370.195 207.873 371.515 230.93Z",
    fill: "#EEB447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.805 167.66L397.808 165.976C397.77 166.063 397.727 166.161 397.682 166.271C397.488 166.74 397.236 167.408 397.004 168.21C396.172 171.038 395.54 175.652 398.764 178.86C398.687 178.949 398.575 179.069 398.423 179.215C398.082 179.543 397.541 179.995 396.748 180.482C395.177 181.447 392.615 182.548 388.665 183.067C388.642 183.05 388.614 183.03 388.582 183.006C388.48 182.931 388.335 182.819 388.165 182.674C387.826 182.385 387.394 181.969 387.015 181.459C386.275 180.464 385.766 179.158 386.469 177.731C386.519 177.722 386.579 177.708 386.647 177.688C386.838 177.631 387.093 177.523 387.367 177.317C387.92 176.901 388.525 176.109 388.866 174.612C389.054 173.817 389.167 172.811 389.147 171.547C389.137 170.453 389.034 169.169 388.805 167.66Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.374 127.734H414.192C413.562 124.494 409.372 120.125 404.818 121.282C405.984 120.098 407.453 119.184 407.453 119.184C407.453 119.184 402.176 117.827 398.239 121.882C394.302 125.937 392.241 134.329 395.691 137.61C396.13 138.027 396.669 137.903 397.257 137.415C400.215 141.403 404.363 137.716 405.089 137.61C405.892 137.492 405.262 139.687 405.262 139.687C407.64 139.749 408.208 136.673 408.208 136.673L410.469 139.687C413.033 137.189 412.127 133.69 412.127 133.69L414.188 135.014C414.59 129.587 411.374 127.734 411.374 127.734Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.324 154.552C377.324 154.552 372.539 141.949 384.945 135.767C397.349 129.586 404.587 138.362 405.04 146.864C405.493 155.366 402.778 162.699 398.708 164.159C394.636 165.618 377.324 154.552 377.324 154.552Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.235 141.892L387.235 141.892C390.622 141.403 393.431 142.616 395.544 144.802C397.662 146.994 399.079 150.168 399.644 153.579C400.776 160.419 398.468 168.058 391.747 170.587L391.747 170.587C389.241 171.53 387.17 171.776 385.463 171.467C383.762 171.159 382.401 170.297 381.315 168.982C379.129 166.334 378.06 161.854 377.666 156.417L377.666 156.417C377.35 152.073 377.709 148.743 379.146 146.355C380.573 143.983 383.095 142.49 387.235 141.892Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76 155.186C382.76 155.186 381.916 157.54 380.826 159.007C380.826 159.007 381.707 160.042 383.169 159.635L382.76 155.186Z",
    fill: "#D58745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.783 153.762C387.866 154.452 388.307 154.966 388.766 154.911C389.226 154.856 389.531 154.251 389.448 153.562C389.364 152.873 388.924 152.358 388.464 152.413C388.006 152.468 387.701 153.072 387.783 153.762Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.661 152.422L387.09 152.015C387.09 152.015 387.989 153.187 388.661 152.422Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19 154.653C379.273 155.342 379.713 155.857 380.173 155.802C380.633 155.747 380.938 155.142 380.855 154.453C380.771 153.763 380.331 153.249 379.871 153.304C379.413 153.359 379.106 153.963 379.19 154.653Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.068 153.314L378.497 152.907C378.497 152.907 379.396 154.078 380.068 153.314Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.033 147.97C387.033 147.97 389.34 147.325 390.845 148.711",
    stroke: "#263238",
    strokeWidth: 0.708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.898 148.495C380.898 148.495 379.341 148.161 377.662 149.665",
    stroke: "#263238",
    strokeWidth: 0.708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.385 154.427C398.385 154.427 393.479 148.117 393.305 142.724C393.305 142.724 375.74 138.344 377.353 155.295C377.353 155.295 373.573 140.583 387.913 138.173C402.231 135.766 405.232 156.816 398.708 164.16C398.708 164.16 401.427 158.379 398.385 154.427Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.273 156.392C397.134 155.036 398.195 152.555 400.741 152.467C403.375 152.375 405.381 157.52 399.114 159.732C398.215 160.049 397.563 159.22 397.273 156.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.945 164.009C384.945 164.009 388.567 164.303 389.572 160.962",
    stroke: "#263238",
    strokeWidth: 0.708,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.331 191.064C366.39 191.579 366.015 191.997 365.493 191.997H356.212C355.69 191.997 355.219 191.58 355.161 191.064L353.089 172.751C353.031 172.236 353.406 171.691 353.927 171.691H363.209C363.73 171.691 364.201 172.235 364.26 172.751L366.331 191.064Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M363.229 172.63L365.329 191.121C365.388 191.643 365.116 191.997 364.598 191.997H356.727C356.199 191.997 355.232 191.707 355.172 191.185L353.073 172.63C353.014 172.109 353.915 171.692 354.443 171.692H362.313C362.832 171.692 363.171 172.109 363.229 172.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.792 190.027L352.12 198.107L347.197 192.56L351.943 184.509L351.977 184.45L351.977 184.381L351.727 184.382L351.977 184.381L351.977 184.381L351.977 184.381L351.977 184.378L351.977 184.369L351.977 184.333C351.977 184.302 351.977 184.255 351.977 184.196C351.978 184.076 351.979 183.905 351.982 183.695C351.987 183.276 351.998 182.708 352.023 182.108C352.048 181.508 352.085 180.879 352.143 180.34C352.201 179.789 352.277 179.364 352.367 179.148C352.399 179.073 352.487 178.956 352.651 178.803C352.811 178.655 353.024 178.491 353.277 178.319C353.782 177.976 354.432 177.611 355.102 177.286C355.771 176.961 356.452 176.68 357.019 176.503C357.303 176.413 357.552 176.352 357.753 176.323C357.959 176.293 358.081 176.302 358.138 176.321C358.141 176.323 358.159 176.337 358.188 176.381C358.226 176.439 358.269 176.528 358.314 176.652C358.403 176.898 358.487 177.245 358.56 177.669C358.707 178.514 358.81 179.628 358.857 180.773C358.904 181.917 358.896 183.082 358.824 184.029C358.789 184.503 358.737 184.917 358.67 185.244C358.601 185.583 358.522 185.792 358.451 185.886C358.264 186.139 357.946 186.414 357.556 186.688C357.17 186.96 356.73 187.22 356.311 187.447C355.894 187.674 355.502 187.866 355.214 188.002C355.07 188.069 354.953 188.123 354.871 188.159C354.831 188.177 354.799 188.191 354.778 188.201L354.753 188.211L354.748 188.214L354.746 188.214L354.746 188.214L354.746 188.214L354.746 188.214L354.573 188.289L354.596 188.475L354.792 190.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.943 191.659L346.551 190.052L354.167 198.597L353.082 201.981L344.943 191.659Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.529 205.313C383.529 205.313 392.486 225.711 404.042 232.32C404.184 228.066 404.824 212.583 407.038 203.932C407.637 201.597 408.348 199.048 409.201 196.235L405.677 192.002C405.677 192.002 403.239 199.555 404.316 206.114L390.841 197.86L383.529 205.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.369 205.833L378.101 195.223L378.062 195.187L378.012 195.169L377.93 195.405L378.012 195.169L378.011 195.169L378.01 195.169L378.006 195.167L377.99 195.162L377.926 195.139C377.869 195.119 377.786 195.09 377.679 195.052C377.467 194.976 377.161 194.867 376.79 194.731C376.049 194.459 375.048 194.082 374.008 193.664C372.967 193.245 371.891 192.785 370.999 192.346C370.553 192.127 370.157 191.915 369.835 191.717C369.509 191.517 369.275 191.341 369.142 191.197C369.016 191.061 368.881 190.821 368.745 190.482C368.612 190.147 368.486 189.735 368.37 189.272C368.139 188.347 367.954 187.234 367.832 186.164C367.71 185.092 367.653 184.073 367.675 183.331C367.687 182.958 367.718 182.67 367.765 182.485C367.777 182.435 367.79 182.398 367.801 182.372C367.907 182.397 368.093 182.45 368.358 182.533C368.697 182.64 369.139 182.789 369.652 182.969C370.677 183.327 371.976 183.805 373.271 184.305C374.566 184.805 375.855 185.326 376.86 185.772C377.363 185.995 377.792 186.198 378.114 186.368C378.275 186.454 378.406 186.529 378.504 186.594C378.609 186.662 378.659 186.706 378.675 186.726L378.675 186.726C378.818 186.896 379.035 187.304 379.288 187.857C379.535 188.398 379.804 189.048 380.054 189.675C380.303 190.301 380.531 190.903 380.697 191.349C380.78 191.572 380.848 191.755 380.895 191.883L380.948 192.03L380.962 192.069L380.966 192.079L380.967 192.081L380.967 192.082L380.967 192.082L381.202 191.997L380.967 192.082L380.991 192.15L381.048 192.194L391.885 200.695L389.369 205.833ZM367.723 182.357L367.723 182.358L367.723 182.357Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.191 180.92C420.648 184.156 423.521 220.621 412.307 226.918C401.093 233.215 384.335 204.763 384.335 204.763L390.845 197.857C390.845 197.857 404.497 209.285 406.145 208.234C407.792 207.184 405.918 196.017 405.918 196.017C405.918 196.017 403.998 192.638 408.038 187.326C412.078 182.013 414.191 180.92 414.191 180.92Z",
    fill: "#EEB447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21 207.294L382.26 206.123L389.574 195.405L392.258 196.902L384.21 207.294Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4 397.611L347.658 406.566L341.287 405.462L343.259 396.729L343.259 396.729L345.49 386.889L352.893 389.427L350.401 397.61L350.4 397.611Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.376 406.674C349.492 405.93 340.113 404.903 340.113 404.903C340.113 404.903 333.384 409.612 327.61 409.933C321.838 410.253 324.348 414.055 330.542 415.129C336.736 416.202 341.463 417.022 345.865 417.786C350.267 418.548 348.178 414.389 349.376 406.674Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.037 406.027C333.883 405.851 333.75 405.533 333.986 405.016C334.101 404.767 334.305 404.589 334.593 404.486C335.137 404.295 335.943 404.414 336.713 404.624C336.031 404.098 335.456 403.504 335.514 403.019C335.552 402.705 335.803 402.482 336.262 402.358C336.693 402.245 337.098 402.301 337.467 402.534C338.631 403.265 339.028 405.519 339.046 405.624C339.052 405.659 339.051 405.697 339.039 405.733H339.038V405.734C339.031 405.755 339.023 405.774 339.012 405.793V405.794C338.995 405.82 338.973 405.843 338.949 405.861C338.925 405.88 338.897 405.892 338.868 405.9C338.424 406.021 336.789 406.44 335.507 406.44C334.86 406.44 334.304 406.332 334.037 406.027ZM334.762 404.946C334.603 405.002 334.497 405.091 334.439 405.218C334.282 405.558 334.382 405.672 334.414 405.709C334.788 406.139 336.576 405.932 338.046 405.6C337.047 405.193 335.497 404.685 334.762 404.946ZM336.392 402.831C336.255 402.867 336.022 402.948 336.007 403.076C335.958 403.49 337.157 404.429 338.438 405.18C338.241 404.437 337.833 403.345 337.198 402.946C337.032 402.842 336.86 402.789 336.677 402.789C336.585 402.791 336.49 402.804 336.392 402.831Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M342.979 396.882L350.607 397.868L353.185 389.362L345.3 386.608L342.979 396.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.54 399.008L393.424 408.295H386.956L387.35 399.357L387.35 399.357L387.805 389.287L395.545 390.524L394.54 399.007L394.54 399.008Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.135 408.107C395.117 407.354 385.701 407.944 385.701 407.944C385.701 407.944 379.907 413.731 374.28 415.031C368.652 416.332 371.797 419.648 378.086 419.648C384.377 419.648 389.177 419.648 393.645 419.648C398.115 419.648 395.322 415.909 395.135 408.107Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.915 410.089C379.733 409.942 379.544 409.651 379.687 409.104C379.756 408.838 379.925 408.627 380.19 408.477C380.69 408.195 381.505 408.173 382.302 408.251C381.537 407.849 380.865 407.361 380.838 406.875C380.819 406.559 381.027 406.298 381.456 406.098C381.86 405.912 382.27 405.9 382.675 406.065C383.952 406.586 384.744 408.745 384.777 408.836C384.8 408.899 384.794 408.966 384.768 409.024C384.758 409.042 384.747 409.059 384.734 409.075C384.713 409.101 384.684 409.123 384.651 409.138C384.156 409.37 382.063 410.31 380.747 410.31C380.402 410.311 380.11 410.247 379.915 410.089ZM380.437 408.9C380.291 408.982 380.203 409.089 380.167 409.224C380.074 409.586 380.191 409.681 380.229 409.713C380.674 410.072 382.399 409.561 383.786 408.985C382.731 408.754 381.117 408.518 380.437 408.9ZM381.669 406.539C381.54 406.599 381.326 406.719 381.333 406.848C381.357 407.264 382.704 407.983 384.1 408.505C383.774 407.806 383.179 406.8 382.484 406.516C382.356 406.464 382.229 406.437 382.102 406.437C381.958 406.437 381.814 406.472 381.669 406.539Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M387.1 399.556L394.788 399.225L395.822 390.409L387.568 389.043L387.1 399.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.334 391.547L353.589 393.495C364.947 365.707 373.025 342.511 378.73 323.262C381.804 312.875 384.198 303.64 386.038 295.444L385.525 325.695V394.413H396.955C424.758 264.203 405.054 234.447 405.054 234.447L371.792 228.865C370.527 233.74 369.571 241.643 369.006 247.145L367.506 257.945L354.504 323.877L342.334 391.547Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.353 392.13L341.392 387.584L341.581 393.416L353.127 397.032L355.353 392.13Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.446 392.764L383.893 390.672L385.112 396.383L397.122 397.972L398.446 392.764Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.054 229.567V234.443L371.134 231.889V226.123L405.054 229.567Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.473 232.835L385.89 233.487L386.394 227.963L378.977 227.312L378.473 232.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.23 235.932L394.913 236.016L395.349 227.601L393.667 227.516L393.23 235.932Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M393.23 235.932L394.913 236.016L395.349 227.601L393.667 227.516L393.23 235.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.507 233.698L374.189 233.782L374.627 225.367L372.945 225.282L372.507 233.698Z",
    fill: "#046CE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M372.507 233.698L374.189 233.782L374.627 225.367L372.945 225.282L372.507 233.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M378.73 323.263C381.804 312.877 384.198 303.641 386.038 295.445C386.038 295.445 385.853 279.517 383.889 266.436C383.889 266.436 379.018 303.853 378.73 323.263Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_455",
    x: 0,
    y: 0,
    width: 516,
    height: 496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImage);
export default __webpack_public_path__ + "static/media/about-image.8d0c5d476283ea69af2a394fbb6e4cad.svg";
export { ForwardRef as ReactComponent };